import React, { useEffect, useMemo, useState } from 'react';
import './style.css';
import {
  Input, Button, List, Card, Tag, Typography, Space, Row, Col, Modal, Form,
  message, Table, Select, InputNumber, Tabs, DatePicker, Tooltip as AntTooltip, Divider, Grid,
  Popconfirm, Avatar, Radio, Tooltip, Drawer, Badge
} from 'antd';
import {
  IoPeopleOutline, IoPersonAddOutline, IoSearchOutline, IoCashOutline, IoNotificationsOutline,
  IoDocumentTextOutline, IoLogoWhatsapp, IoCallOutline, IoMailOutline, IoStorefrontOutline,
  IoChevronForwardOutline, IoFilterOutline
} from 'react-icons/io5';
import {
  EditOutlined, DeleteOutlined, UserOutlined, FilePdfOutlined, EyeOutlined,
  EnvironmentOutlined, DownloadOutlined, SettingOutlined
} from '@ant-design/icons';
import LayoutHome from '../../components/layout/LayoutHome';
import { useAuth } from '../../aws/AuthContext';
import { useCaja } from '../../hooks/useCaja';
import { useConfig } from '../../context/ConfigContext';
import axios from 'axios';
import dayjs from 'dayjs';
import { useGetNotasCRM, useSaveNotaCRM, useUpdateNotaCRM, useDeleteNotaCRM } from '../../hooks/useClientes';
import TicketComprobante from '../../components/impresiones/TicketComprobante';
import TicketDetalleVentaFactura from '../../components/impresiones/TicketDetalleVentaFactura';
import { pdf } from '@react-pdf/renderer';
import { FacturaFormal } from '../ventas/FacturaFormal';
import { useZonas } from '../../hooks/useZonas';
import { useCategoriasClientes } from '../../hooks/useCategoriasClientes';
import ModalCrearCliente from './modals/ModalCrearCliente';
import ModalConfigCampos from './modals/ModalConfigCampos';
import ModalExportarClientes from './modals/ModalExportarClientes';
import { usePermission } from '../../hooks/usePermission';

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const API_BASE_URL = process.env.REACT_APP_API_URL;
const API_URL = `${API_BASE_URL}/v1-clientes`;

const Clientes = () => {

  const screens = useBreakpoint();
  const isMobile = screens.md === false;

  const { hasPermission } = usePermission();

  const { zonas = [] } = useZonas();
  const { getJwtToken, user } = useAuth();
  const { getCajaActiva } = useCaja();
  const cajaActiva = getCajaActiva?.data;
  const { categorias = [] } = useCategoriasClientes();

  const [busqueda, setBusqueda] = useState('');
  const [filtro, setFiltro] = useState('todos');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [formNota] = Form.useForm();
  const [formAbono] = Form.useForm();

  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [isDetailModalOpenMobile, setIsDetailModalOpenMobile] = useState(false);

  const [isDebtOpen, setIsDebtOpen] = useState(false);
  const [isAbonando, setIsAbonando] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ventaSeleccionada, setVentaSeleccionada] = useState(null);
  const [facturasCliente, setFacturasCliente] = useState([]);
  const [loadingFacturas, setLoadingFacturas] = useState(false);
  const [isAbonoGlobal, setIsAbonoGlobal] = useState(false);
  const [movimientos, setMovimientos] = useState([]);
  const [loadingMovimientos, setLoadingMovimientos] = useState(false);

  const { config } = useConfig();
  const diasVencimiento = parseInt(config.dias_vencimiento_cartera, 10) || 30;

  const [ventasPendientes, setVentasPendientes] = useState([]);
  const [loadingVentasPendientes, setLoadingVentasPendientes] = useState(false);
  const [isDetalleFacturaOpen, setIsDetalleFacturaOpen] = useState(false);
  const [facturaDetalleSeleccionada, setFacturaDetalleSeleccionada] = useState(null);

  const [notaEditando, setNotaEditando] = useState(null);
  const { data: notasCRM = [], isLoading: cargandoNotasCRM } = useGetNotasCRM(clienteSeleccionado?.id);
  const saveNotaCRM = useSaveNotaCRM();
  const updateNotaCRM = useUpdateNotaCRM();
  const deleteNotaCRM = useDeleteNotaCRM();

  const [isExpandedForm, setIsExpandedForm] = useState(false);
  const [showReminder, setShowReminder] = useState(false);
  const [isReciboModalOpen, setIsReciboModalOpen] = useState(false);
  const [reciboSeleccionado, setReciboSeleccionado] = useState(null);

  const [filtroCreador, setFiltroCreador] = useState('');
  const [filtroCategoria, setFiltroCategoria] = useState('');

  const [activeTab, setActiveTab] = useState('1');

  const [isConfigModalOpen, setIsConfigModalOpen] = useState(false);

  const [openExport, setOpenExport] = useState(false);
  const [drawerFiltros, setDrawerFiltros] = useState(false);
  const filtrosActivos = (filtroCreador ? 1 : 0) + (filtroCategoria ? 1 : 0);

  // Obtener el objeto parseado para pasarlo al formulario:
  const configCamposParseada = useMemo(() => {
    try {
      return JSON.parse(config?.settings?.campos_clientes || "{}");
    } catch (e) {
      return {};
    }
  }, [config?.settings?.campos_clientes]);

  const opcionesCreadores = useMemo(() => {
    const creadoresMap = new Map();
    clientes.forEach(c => {
      if (c.creado_por_usuario_id) {
        creadoresMap.set(c.creado_por_usuario_id, c.creador_nombre || c.creador_email || 'Usuario');
      }
    });
    return Array.from(creadoresMap.entries()).map(([id, nombre]) => ({ id, nombre }));
  }, [clientes]);

  const fetchClientes = async () => {
    setLoading(true);
    try {
      const token = await getJwtToken();
      const response = await axios.get(API_URL, { headers: { Authorization: `Bearer ${token}` } });
      setClientes(response.data);
    } catch (error) {
      message.error("No se pudieron cargar los clientes");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchClientes(); }, []);

  const fetchVentasPendientes = async () => {
    setLoadingVentasPendientes(true);
    try {
      const token = await getJwtToken();
      const res = await axios.get(`${API_BASE_URL}/v1-ventas?status_pago=pendiente`, { headers: { Authorization: `Bearer ${token}` } });
      setVentasPendientes(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      setVentasPendientes([]);
    } finally {
      setLoadingVentasPendientes(false);
    }
  };

  useEffect(() => { fetchVentasPendientes(); }, []);

  const clientesSeguros = Array.isArray(clientes) ? clientes : [];

  const clientesFiltrados = clientesSeguros.filter(c => {
    const docStr = c.documento ? String(c.documento) : '';
    const coincideBusqueda = c.nombre?.toLowerCase().includes(busqueda.toLowerCase()) || docStr.includes(busqueda);
    const coincideCreador = !filtroCreador || c.creado_por_usuario_id === filtroCreador;
    const coincideCategoria = !filtroCategoria || c.categoria_id === filtroCategoria;
    const saldo = Number(c.saldo_pendiente) || 0;

    if (!coincideBusqueda || !coincideCreador || !coincideCategoria) return false;

    if (filtro === 'deudores') return saldo > 0;
    if (filtro === 'alDia') return saldo <= 0;
    if (filtro === 'conAlerta') return c.tiene_alerta;

    if (filtro === 'vencidos') {
      const msPorDia = 1000 * 60 * 60 * 24;
      const hoyMid = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

      return ventasPendientes.some(v => {
        if (v.cliente_id !== c.id) return false;
        const raw = v?.fecha || v?.created_at || v?.createdAt;
        if (!raw) return false;
        const fechaMid = new Date(new Date(raw).getFullYear(), new Date(raw).getMonth(), new Date(raw).getDate());
        const dias = Math.floor((hoyMid.getTime() - fechaMid.getTime()) / msPorDia);
        const saldoFac = Number(v?.saldo_pendiente_factura ?? v?.saldo_pendiente ?? v?.total ?? 0) || 0;
        return dias > (parseInt(config.dias_vencimiento_cartera, 10) || 30) && saldoFac > 0;
      });
    }

    return true;
  });

  const totalAdeudado = clientesSeguros.reduce((acc, curr) => acc + (Number(curr.saldo_pendiente) || 0), 0);
  const cantidadDeudores = clientesSeguros.filter(c => (Number(c.saldo_pendiente) || 0) > 0).length;
  const totalClientes = clientesSeguros.length;
  const totalLimites = clientesSeguros.reduce((acc, c) => acc + (Number(c.limite_credito) || 0), 0);
  const porcentajeCupo = totalLimites > 0 ? ((totalAdeudado / totalLimites) * 100).toFixed(1) : 0;

  const carteraVencida = useMemo(() => {
    const msPorDia = 1000 * 60 * 60 * 24;
    const hoy = new Date();
    const hoyMid = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());

    // 1. Creamos un Set con los IDs de los clientes que el usuario actual tiene permiso de ver
    const clientesPermitidosIds = new Set(clientesSeguros.map(c => c.id));

    const getFechaVenta = (v) => {
      const raw = v?.fecha || v?.created_at || v?.createdAt;
      if (!raw) return null;
      const d = new Date(raw);
      return Number.isNaN(d.getTime()) ? null : d;
    };

    return (Array.isArray(ventasPendientes) ? ventasPendientes : [])
      // 2. MAGIA: Solo calculamos vencimiento para ventas de MIS clientes permitidos
      .filter(v => clientesPermitidosIds.has(v.cliente_id))
      .map(v => {
        const fecha = getFechaVenta(v);
        if (!fecha) return { vencida: false, saldo: 0 };
        const fechaMid = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());
        const dias = Math.floor((hoyMid.getTime() - fechaMid.getTime()) / msPorDia);
        const saldo = Number(v?.saldo_pendiente_factura ?? v?.saldo_pendiente ?? v?.total ?? 0) || 0;
        const umbral = Number(diasVencimiento);
        const vencida = umbral === 0 ? true : dias > umbral;
        return { vencida, saldo };
      })
      .filter(x => x.vencida && x.saldo > 0)
      .reduce((acc, x) => acc + x.saldo, 0);
  }, [ventasPendientes, diasVencimiento, clientesSeguros]); // <-- Agregamos clientesSeguros a las dependencias

  const handleCrearCliente = async (values) => {
    setLoading(true);
    try {
      const token = await getJwtToken();
      const configReq = { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } };

      const payload = { ...values };

      // Buscar la zona elegida para mostrar su nombre localmente
      const zonaElegida = zonas.find(z => Number(z.id) === Number(payload.zona_id));

      let clienteActualizado;

      if (isEditing) {
        // 2. Enviamos "payload" en lugar de "values"
        await axios.put(`${API_URL}/${clienteSeleccionado.id}`, payload, configReq);

        clienteActualizado = {
          ...clienteSeleccionado,
          ...payload,
          zona_id: payload.zona_id ? Number(payload.zona_id) : null,
          zona_nombre: zonaElegida ? zonaElegida.nombre : null
        };
        message.success("Cliente actualizado correctamente");
      } else {
        // 2. Enviamos "payload" en lugar de "values"
        const res = await axios.post(API_URL, payload, configReq);
        clienteActualizado = {
          id: res.data.id,
          ...payload,
          saldo_pendiente: 0,
          zona_id: payload.zona_id ? Number(payload.zona_id) : null,
          zona_nombre: zonaElegida ? zonaElegida.nombre : null,
          creado_por_usuario_id: user?.attributes?.sub || null
        };
        message.success("Cliente registrado con éxito");
      }

      setIsModalOpen(false);
      form.resetFields();

      // Refrescar lista completa desde el backend
      await fetchClientes();

      // Actualizar la ficha visible en pantalla con los datos combinados
      setClienteSeleccionado(clienteActualizado);

    } catch (error) {
      message.error(error.response?.data?.error || "Error al procesar la solicitud");
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmarAbono = async (values) => {
    setLoading(true);
    try {
      const token = await getJwtToken();
      const montoPagado = Number(String(values.monto_abono).replace(/[^0-9.-]+/g, ""));

      const payloadAbono = {
        cliente_id: clienteSeleccionado.id,
        monto: montoPagado,
        metodo_pago: values.metodo_pago,
        notas: values.nota || '',
        tipo_abono: isAbonoGlobal ? 'global' : 'individual',
        sesion_caja_id: cajaActiva?.id,
        ...(!isAbonoGlobal && { venta_id: ventaSeleccionada?.id })
      };

      await axios.post(`${API_BASE_URL}/v1-abonos`, payloadAbono, { headers: { Authorization: `Bearer ${token}` } });
      message.success(`Pago de $${montoPagado.toLocaleString('es-CO')} registrado.`);

      const nuevoSaldo = Math.max(0, Number(clienteSeleccionado.saldo_pendiente) - montoPagado);

      setClienteSeleccionado({
        ...clienteSeleccionado,
        saldo_pendiente: nuevoSaldo
      });

      setIsAbonando(false);
      setIsDebtOpen(false);
      formAbono.resetFields(['monto_abono', 'metodo_pago', 'nota']);

      await fetchClientes();
      await cargarFacturasPendientes(clienteSeleccionado.id);
      cargarHistorialCompleto(clienteSeleccionado.id);

    } catch (error) {
      message.error(error.response?.data?.error || "Error al registrar pago.");
    } finally {
      setLoading(false);
    }
  };

  const cargarFacturasPendientes = async (clienteId) => {
    setLoadingFacturas(true);
    try {
      const token = await getJwtToken();
      const response = await axios.get(`${API_BASE_URL}/v1-ventas?cliente_id=${clienteId}&status_pago=pendiente`, { headers: { Authorization: `Bearer ${token}` } });
      setFacturasCliente(response.data);
    } catch (error) {
      message.error("Error al cargar facturas.");
    } finally {
      setLoadingFacturas(false);
    }
  };

  const cargarHistorialCompleto = async (clienteId) => {
    setLoadingMovimientos(true);
    try {
      const token = await getJwtToken();
      const [resVentas, resAbonos] = await Promise.all([
        axios.get(`${API_BASE_URL}/v1-ventas?cliente_id=${clienteId}`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${API_BASE_URL}/v1-abonos?cliente_id=${clienteId}`, { headers: { Authorization: `Bearer ${token}` } })
      ]);

      const ventasMap = resVentas.data.map(v => ({ ...v, tipo: 'COMPRA', color: 'blue', monto: v.total }));
      const abonosMap = resAbonos.data.map(a => ({ ...a, tipo: 'ABONO', color: 'green', monto: a.monto }));

      setMovimientos([...ventasMap, ...abonosMap].sort((a, b) => new Date(b.fecha) - new Date(a.fecha)));
    } catch (error) {
      message.error("Error al cargar historial");
    } finally {
      setLoadingMovimientos(false);
    }
  };

  const handleGuardarNota = (values) => {
    const payload = {
      cliente_id: clienteSeleccionado.id,
      titulo: values.titulo || null,
      tipo_contacto: showReminder ? (values.tipo_contacto || 'nota') : 'nota',
      nota: values.nota,
      fecha_recordatorio: showReminder && values.fecha_recordatorio ? values.fecha_recordatorio.format('YYYY-MM-DD') : null
    };

    if (notaEditando) {
      updateNotaCRM.mutate({ id: notaEditando.id, ...payload }, {
        onSuccess: () => {
          message.success("Nota actualizada");
          handleCancelarEdicionNota();
        },
        onError: () => message.error("Error al actualizar la nota")
      });
    } else {
      saveNotaCRM.mutate(payload, {
        onSuccess: () => {
          message.success("Nota guardada");
          handleCancelarEdicionNota();
        },
        onError: () => message.error("Error al guardar la nota")
      });
    }
  };

  const handlePrepararEdicionNota = (nota) => {
    setNotaEditando(nota);
    setIsExpandedForm(true);
    setShowReminder(!!nota.fecha_recordatorio);
    formNota.setFieldsValue({
      titulo: nota.titulo,
      tipo_contacto: nota.tipo_contacto || 'nota',
      nota: nota.nota,
      fecha_recordatorio: nota.fecha_recordatorio ? dayjs(nota.fecha_recordatorio) : null
    });
  };

  const handleCancelarEdicionNota = () => {
    setNotaEditando(null);
    formNota.resetFields();
    setIsExpandedForm(false);
    setShowReminder(false);
  };

  const handleEliminarNota = (id) => {
    deleteNotaCRM.mutate(id, {
      onSuccess: () => message.success("Nota eliminada del historial"),
      onError: () => message.error("No se pudo eliminar la nota")
    });
  };

  const seleccionarCliente = (cliente) => {
    setClienteSeleccionado(cliente);
    cargarHistorialCompleto(cliente.id);
    cargarFacturasPendientes(cliente.id);

    setActiveTab('1');
    setIsExpandedForm(false);
    setShowReminder(false);
    if (isMobile) setIsDetailModalOpenMobile(true);
  }

  const notasCRMSortadas = useMemo(() => {
    if (!notasCRM || notasCRM.length === 0) return [];
    const hoy = dayjs().startOf('day');
    return [...notasCRM].sort((a, b) => {
      const isAlertaA = a.fecha_recordatorio && (dayjs(a.fecha_recordatorio).startOf('day').isSame(hoy) || dayjs(a.fecha_recordatorio).startOf('day').isBefore(hoy));
      const isAlertaB = b.fecha_recordatorio && (dayjs(b.fecha_recordatorio).startOf('day').isSame(hoy) || dayjs(b.fecha_recordatorio).startOf('day').isBefore(hoy));
      if (isAlertaA && !isAlertaB) return -1;
      if (!isAlertaA && isAlertaB) return 1;
      return new Date(b.fecha_creacion) - new Date(a.fecha_creacion);
    });
  }, [notasCRM]);

  const handleOpenEditar = () => {
    setIsEditing(true);
    form.setFieldsValue({
      ...clienteSeleccionado,
      zona_id: clienteSeleccionado?.zona_id ? Number(clienteSeleccionado.zona_id) : undefined,
      nombre_comercial: clienteSeleccionado?.nombre_comercial || '',
      barrio: clienteSeleccionado?.barrio || '',
      ciudad: clienteSeleccionado?.ciudad || '',
      notas: clienteSeleccionado?.notas || ''
    });
    setIsModalOpen(true);
    if (isMobile) setIsDetailModalOpenMobile(false);
  };

  const renderFichaCliente = () => {
    if (!clienteSeleccionado) return (
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: '#cbd5e1' }}>
        <IoPeopleOutline size={64} style={{ marginBottom: '16px' }} />
        <Title level={4} style={{ color: '#94a3b8' }}>Ningún cliente seleccionado</Title>
        <Text style={{ color: '#94a3b8', textAlign: 'center' }}>Selecciona un cliente de la lista para ver sus detalles, finanzas y notas CRM.</Text>
      </div>
    );

    return (
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>

        {/* HEADER DEL CLIENTE (Responsivo) */}
        <div style={{
          padding: '0 0 16px 0', borderBottom: '1px solid #e2e8f0', marginBottom: '16px',
          display: 'flex', flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'space-between', alignItems: isMobile ? 'stretch' : 'flex-start', gap: '16px'
        }}>

          <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
            <Avatar size={isMobile ? 50 : 64} style={{ backgroundColor: '#22BABB', fontSize: '24px' }} icon={<UserOutlined />} />
            <div style={{ minWidth: 0, flex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px', flexWrap: 'wrap' }}>
                <Title level={isMobile ? 4 : 3} style={{ margin: 0, color: '#0f172a', wordBreak: 'break-word' }}>
                  {clienteSeleccionado.nombre}
                </Title>
                <Tag color={clienteSeleccionado.status_credito === 'activo' ? 'green' : 'red'} style={{ margin: 0 }}>
                  {clienteSeleccionado.status_credito?.toUpperCase()}
                </Tag>

                {/* Insignia de la Zona en la ficha */}
                {clienteSeleccionado.zona_nombre && (
                  <Tag icon={<EnvironmentOutlined />} color="cyan" style={{ margin: 0, fontWeight: 600 }}>
                    {clienteSeleccionado.zona_nombre}
                  </Tag>
                )}
                {clienteSeleccionado.categoria_nombre && (
                  <Tag color="purple" style={{ margin: 0, fontWeight: 600 }}>
                    {clienteSeleccionado.categoria_nombre}
                  </Tag>
                )}
              </div>
              <Space direction={isMobile ? "vertical" : "horizontal"} size={isMobile ? 0 : "middle"} style={{ width: '100%', flexWrap: 'wrap' }}>
                <Text type="secondary" style={{ fontSize: '13px', display: 'block' }}><strong>NIT:</strong> {clienteSeleccionado.documento || 'N/A'}</Text>
                <Text type="secondary" style={{ fontSize: '13px', display: 'block' }}><strong>Tel:</strong> {clienteSeleccionado.telefono || 'N/A'}</Text>
                <Text type="secondary" style={{ fontSize: '13px', display: 'block', wordBreak: 'break-all' }}><strong>Email:</strong> {clienteSeleccionado.email || 'N/A'}</Text>
                <Text type="secondary" style={{ fontSize: '13px', display: 'block' }}>
                  <strong>Ubicación:</strong> {[clienteSeleccionado.direccion, clienteSeleccionado.barrio, clienteSeleccionado.ciudad].filter(Boolean).join(', ') || 'N/A'}
                </Text>
                {clienteSeleccionado.creador_nombre && (
                  <Text type="secondary" style={{ fontSize: '13px', display: 'block', color: '#64748b' }}>
                    <strong>Creado por:</strong> {clienteSeleccionado.creador_nombre}
                  </Text>
                )}
              </Space>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: isMobile ? 'stretch' : 'flex-end', gap: '12px' }}>
            {Number(clienteSeleccionado.saldo_pendiente) > 0 && (
              <div title='Total de la deuda' style={{ textAlign: isMobile ? 'center' : 'right', backgroundColor: '#fef2f2', padding: '10px', borderRadius: '8px', border: '1px solid #fca5a5' }}>
                <Text style={{ fontSize: '11px', fontWeight: 800, color: '#ef4444', letterSpacing: '0.5px' }}>DEUDA TOTAL</Text>
                <Title level={isMobile ? 3 : 4} style={{ margin: 0, color: '#dc2626', lineHeight: 1 }}>${Number(clienteSeleccionado.saldo_pendiente).toLocaleString('es-CO')}</Title>
              </div>
            )}
            <Space direction={isMobile ? "vertical" : "horizontal"} style={{ width: '100%' }}>
              <Button
                block={isMobile}
                icon={<EditOutlined />}
                title='Editar datos del cliente'
                size='large'
                onClick={handleOpenEditar}
              >
                Editar Perfil
              </Button>
              {Number(clienteSeleccionado.saldo_pendiente) > 0 && (
                <Button
                  block={isMobile}
                  type="primary"
                  size='large'
                  title='Abonar a deuda total'
                  icon={<IoCashOutline size={18} />}
                  style={{ backgroundColor: '#22c55e', borderColor: '#22c55e', fontWeight: 'bold', borderRadius: '10px', padding: '0 20px', boxShadow: '0 4px 6px -1px rgba(34, 186, 187, 0.2)' }}
                  onClick={() => {
                    setVentaSeleccionada(null);
                    setIsAbonoGlobal(true);
                    setIsAbonando(false);
                    setIsDebtOpen(true);
                    formAbono.resetFields(['monto_abono', 'metodo_pago', 'nota']);
                  }}>Abonar a Total</Button>
              )}
            </Space>
          </div>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', paddingRight: isMobile ? '0' : '10px' }} className="scroll-personalizado">
          <Tabs activeKey={activeTab} onChange={setActiveTab}>

            {/* CARTERA */}
            <Tabs.TabPane tab="Cartera (Deudas)" key="1">
              <Row gutter={16} style={{ marginBottom: '20px' }}>
                <Col span={12}>
                  <Card size="small" style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                    <Text type="secondary" style={{ fontSize: '11px', fontWeight: 600 }}>CUPO APROBADO</Text>
                    <Title level={isMobile ? 5 : 4} style={{ margin: 0, color: '#0ea5e9' }}>${Number(clienteSeleccionado.limite_credito || 0).toLocaleString('es-CO')}</Title>
                  </Card>
                </Col>
                <Col span={12}>
                  <Card size="small" style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                    <Text type="secondary" style={{ fontSize: '11px', fontWeight: 600 }}>CUPO DISPONIBLE</Text>
                    <Title level={isMobile ? 5 : 4} style={{ margin: 0, color: '#10b981' }}>${Math.max(0, Number(clienteSeleccionado.limite_credito || 0) - Number(clienteSeleccionado.saldo_pendiente || 0)).toLocaleString('es-CO')}</Title>
                  </Card>
                </Col>
              </Row>

              <Title level={5} style={{ margin: '0 0 12px 0' }}>Facturas Pendientes</Title>

              <Table
                size="small"
                scroll={{ x: 450 }}
                pagination={{ pageSize: 5 }}
                dataSource={facturasCliente}
                loading={loadingFacturas}
                rowKey="id"
                columns={[
                  { title: 'DOCUMENTO', dataIndex: 'numero_factura', render: (t) => <Text strong style={{ color: '#22BABB' }}>{String(t).slice(0, 8)}</Text> },
                  { title: 'FECHA', dataIndex: 'fecha', render: (f) => <Text style={{ color: '#8c8c8c', fontSize: '12px' }}>{new Date(f).toLocaleDateString()}</Text> },
                  { title: 'TOTAL', dataIndex: 'total', align: 'right', render: (val) => <Text strong>${Number(val || 0).toLocaleString('es-CO')}</Text> },
                  { title: 'SALDO', dataIndex: 'saldo_pendiente_factura', align: 'right', render: (val) => <Text type="danger" strong>${Number(val || 0).toLocaleString('es-CO')}</Text> },
                  {
                    title: 'ACCIÓN', key: 'accion', align: 'center',
                    render: (_, record) => (
                      <Space size="small">
                        <Tooltip title="Ver Detalles"><Button type="text" icon={<EyeOutlined />} onClick={() => { setFacturaDetalleSeleccionada(record); setIsDetalleFacturaOpen(true); }} /></Tooltip>
                        <Button type="primary" size="small" style={{ backgroundColor: '#22BABB', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold' }} onClick={() => { setVentaSeleccionada(record); setIsAbonando(true); setIsAbonoGlobal(false); setIsDebtOpen(true); formAbono.setFieldsValue({ monto_abono: record.saldo_pendiente_factura }); }}>Abonar</Button>
                      </Space>
                    )
                  }
                ]}
                locale={{ emptyText: 'No hay facturas pendientes o atrasadas' }}
              />
            </Tabs.TabPane>

            {/* CRM */}
            <Tabs.TabPane tab="CRM" key="3">
              <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Card size="small" bordered={false} style={{ borderRadius: '12px', marginBottom: '24px', backgroundColor: '#fff', border: '1px solid #e2e8f0', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                  {!isExpandedForm ? (
                    <div onClick={() => setIsExpandedForm(true)} style={{ cursor: 'text', padding: '12px 16px', display: 'flex', alignItems: 'center', color: '#94a3b8' }}>
                      <IoDocumentTextOutline size={18} style={{ marginRight: '10px' }} />
                      <span style={{ fontSize: '15px' }}>Agregar nota al historial...</span>
                    </div>
                  ) : (
                    <Form form={formNota} layout="vertical" onFinish={handleGuardarNota} initialValues={{ tipo_contacto: 'nota' }}>
                      <Form.Item name="titulo" style={{ marginBottom: 0 }}>
                        <Input placeholder="Título de la nota (Opcional)" bordered={false} style={{ fontWeight: 700, fontSize: '16px', padding: '12px 16px' }} />
                      </Form.Item>
                      <Form.Item name="nota" rules={[{ required: true, message: 'La nota no puede estar vacía' }]} style={{ marginBottom: '12px' }}>
                        <Input.TextArea rows={3} placeholder="Detalle de la nota..." bordered={false} style={{ resize: 'none', padding: '0 16px', fontSize: '14px' }} autoFocus />
                      </Form.Item>
                      {showReminder && (
                        <div style={{ backgroundColor: '#f8fafc', padding: '12px 16px', borderTop: '1px solid #f1f5f9' }}>
                          <Row gutter={16}>
                            <Col xs={24} sm={12}>
                              <Form.Item name="fecha_recordatorio" label={<Text strong style={{ fontSize: '11px', color: '#64748b' }}>FECHA ALARMA</Text>} style={{ marginBottom: isMobile ? 12 : 0 }}>
                                <DatePicker placeholder="Seleccionar" format="DD/MM/YYYY" style={{ width: '100%', borderRadius: '6px' }} />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12}>
                              <Form.Item name="tipo_contacto" label={<Text strong style={{ fontSize: '11px', color: '#64748b' }}>CANAL</Text>} style={{ marginBottom: 0 }}>
                                <Select style={{ borderRadius: '6px' }}>
                                  <Select.Option value="nota"><div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><IoDocumentTextOutline /> Solo Nota</div></Select.Option>
                                  <Select.Option value="whatsapp"><div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#25D366' }}><IoLogoWhatsapp /> WhatsApp</div></Select.Option>
                                  <Select.Option value="llamada"><div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#22BABB' }}><IoCallOutline /> Llamada</div></Select.Option>
                                  <Select.Option value="visita"><div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#722ed1' }}><IoStorefrontOutline /> Presencial</div></Select.Option>
                                  <Select.Option value="correo"><div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#faad14' }}><IoMailOutline /> Correo</div></Select.Option>
                                </Select>
                              </Form.Item>
                            </Col>
                          </Row>
                        </div>
                      )}
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 16px 12px 16px' }}>
                        <div>{!showReminder && <AntTooltip title="Agregar alarma"><Button type="text" shape="circle" icon={<IoNotificationsOutline size={20} />} onClick={() => setShowReminder(true)} style={{ color: '#64748b' }} /></AntTooltip>}</div>
                        <Space>
                          <Button type="text" onClick={handleCancelarEdicionNota} style={{ fontWeight: 600, color: '#64748b' }}>Cerrar</Button>
                          <Button type="primary" htmlType="submit" loading={saveNotaCRM.isLoading || updateNotaCRM.isLoading} style={{ backgroundColor: '#22BABB', borderRadius: '8px', fontWeight: 'bold' }}>{notaEditando ? 'Actualizar' : 'Guardar'}</Button>
                        </Space>
                      </div>
                    </Form>
                  )}
                </Card>

                {/* TIMELINE CRM */}
                <div style={{ flex: 1, paddingRight: '5px' }}>
                  <List
                    dataSource={notasCRMSortadas}
                    locale={{ emptyText: 'No hay notas registradas.' }}
                    renderItem={nota => {
                      const getIcono = (tipo) => {
                        switch (tipo) {
                          case 'whatsapp': return <div style={{ background: '#dcf8c6', padding: '8px', borderRadius: '50%' }}><IoLogoWhatsapp size={18} color="#25D366" /></div>;
                          case 'llamada': return <div style={{ background: '#e0f2fe', padding: '8px', borderRadius: '50%' }}><IoCallOutline size={18} color="#22BABB" /></div>;
                          case 'correo': return <div style={{ background: '#fffbe6', padding: '8px', borderRadius: '50%' }}><IoMailOutline size={18} color="#faad14" /></div>;
                          case 'visita': return <div style={{ background: '#f3e8ff', padding: '8px', borderRadius: '50%' }}><IoStorefrontOutline size={18} color="#722ed1" /></div>;
                          default: return <div style={{ background: '#f1f5f9', padding: '8px', borderRadius: '50%' }}><IoDocumentTextOutline size={18} color="#64748b" /></div>;
                        }
                      };
                      const hoy = dayjs().startOf('day');
                      const fechaRec = dayjs(nota.fecha_recordatorio).startOf('day');
                      const isAlertaActiva = nota.fecha_recordatorio && (fechaRec.isSame(hoy) || fechaRec.isBefore(hoy));
                      const bgCard = isAlertaActiva ? '#fff1f0' : '#fff';
                      const borderLeftCard = isAlertaActiva ? '4px solid #f5222d' : (nota.fecha_recordatorio ? '4px solid #faad14' : '1px solid #e2e8f0');

                      return (
                        <List.Item style={{ padding: '0 0 16px 0', border: 'none' }}>
                          <div style={{ display: 'flex', gap: '12px', width: '100%', alignItems: 'flex-start' }}>
                            <div style={{ marginTop: '4px' }}>{getIcono(nota.tipo_contacto)}</div>
                            <div style={{ flex: 1, padding: '16px', borderLeft: borderLeftCard, backgroundColor: bgCard, borderRadius: '12px', border: '1px solid #e2e8f0', minWidth: 0 }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
                                <Space direction="vertical" size={2}>
                                  {nota.titulo && <Text strong style={{ fontSize: '15px', color: '#0f172a' }}>{nota.titulo}</Text>}
                                  <Text type="secondary" style={{ fontSize: '11px', fontWeight: 600 }}>{new Date(nota.fecha_creacion).toLocaleDateString('es-CO', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}</Text>
                                </Space>
                                <Space size="small" align="start">
                                  <Button type="text" size="small" icon={<EditOutlined />} style={{ color: '#22BABB' }} onClick={() => handlePrepararEdicionNota(nota)} />
                                  <Popconfirm title="¿Eliminar nota?" onConfirm={() => handleEliminarNota(nota.id)} okButtonProps={{ danger: true }}><Button type="text" danger size="small" icon={<DeleteOutlined />} loading={deleteNotaCRM.isLoading} /></Popconfirm>
                                </Space>
                              </div>
                              <Text style={{ color: '#334155', fontSize: '14px', whiteSpace: 'pre-wrap' }}>{nota.nota}</Text>
                              {nota.fecha_recordatorio && (
                                <div style={{ marginTop: '12px' }}>
                                  <Tag color={isAlertaActiva ? "error" : "default"} style={{ borderRadius: '12px', padding: '2px 10px', fontWeight: 600, display: 'inline-flex', alignItems: 'center' }}>
                                    <IoNotificationsOutline style={{ marginRight: '4px' }} />
                                    {isAlertaActiva ? 'Atender hoy/vencida: ' : 'Recordatorio: '}
                                    {new Date(nota.fecha_recordatorio).toLocaleDateString('es-CO')}
                                  </Tag>
                                </div>
                              )}
                            </div>
                          </div>
                        </List.Item>
                      );
                    }}
                  />
                </div>
              </div>
            </Tabs.TabPane>

            {/* HISTORIAL */}
            <Tabs.TabPane tab="Movimientos" key="2">
              <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                {/* HEADER DE LA TABLA */}
                {!isMobile && (
                  <div style={{
                    display: 'flex', padding: '12px 16px', borderBottom: '1px solid #e2e8f0',
                    backgroundColor: '#f8fafc', fontWeight: '700', fontSize: '12px',
                    color: '#64748b', textTransform: 'uppercase', borderRadius: '8px 8px 0 0'
                  }}>
                    <div style={{ flex: 1 }}>Tipo</div>
                    <div style={{ flex: 2 }}>Fecha</div>
                    <div style={{ flex: 1, textAlign: 'right' }}>Monto</div>
                    <div style={{ flex: 1, textAlign: 'center' }}>Acciones</div>
                  </div>
                )}

                {/* FILAS DE DATOS */}
                <div className="scroll-personalizado" style={{ flex: 1, overflowY: 'auto' }}>
                  {loadingMovimientos ? (
                    <div style={{ padding: '20px', textAlign: 'center' }}><Text>Cargando movimientos...</Text></div>
                  ) : movimientos.length === 0 ? (
                    <div style={{ padding: '20px', textAlign: 'center', color: '#94a3b8' }}>No hay movimientos registrados.</div>
                  ) : (
                    movimientos.map((item, index) => (
                      isMobile ? (
                        /* VISTA MÓVIL */
                        <div key={index} style={{ padding: '12px', borderBottom: '1px solid #f1f5f9', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Tag color={item.color} style={{ margin: 0, fontWeight: 'bold' }}>{item.tipo}</Tag>
                            <Text strong style={{ color: item.tipo === 'COMPRA' ? '#0f172a' : '#10b981', fontSize: '15px' }}>
                              ${Number(item.monto).toLocaleString('es-CO')}
                            </Text>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Text type="secondary" style={{ fontSize: '12px' }}>
                              {new Date(item.fecha).toLocaleString('es-CO', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                            </Text>
                            {item.tipo === 'COMPRA' ? (
                              <Tooltip title="Descargar PDF"><Button type="text" icon={<FilePdfOutlined />} style={{ color: '#d32f2f', background: '#fce4e4' }} onClick={() => handleImprimirFacturaDesdeHistorial(item)} /></Tooltip>
                            ) : (
                              <Tooltip title="Ver Detalles"><Button type="text" icon={<EyeOutlined />} onClick={() => { setReciboSeleccionado(item); setIsReciboModalOpen(true); }} /></Tooltip>
                            )}
                          </div>
                        </div>
                      ) : (
                        /* VISTA ESCRITORIO */
                        <div key={index} style={{
                          display: 'flex', padding: '12px 16px', borderBottom: '1px solid #f1f5f9',
                          alignItems: 'center', transition: 'background 0.2s'
                        }}>
                          <div style={{ flex: 1 }}>
                            <Tag color={item.color} style={{ fontSize: '10px', fontWeight: 'bold', borderRadius: '4px' }}>{item.tipo}</Tag>
                          </div>
                          <div style={{ flex: 2, fontSize: '12px', color: '#475569' }}>
                            {new Date(item.fecha).toLocaleDateString('es-CO', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                          </div>
                          <div style={{ flex: 1, textAlign: 'right', fontWeight: '600', color: item.tipo === 'COMPRA' ? '#0f172a' : '#10b981' }}>
                            ${Number(item.monto).toLocaleString('es-CO')}
                          </div>
                          <div style={{ flex: 1, textAlign: 'center' }}>
                            {item.tipo === 'COMPRA' ? (
                              <Tooltip title="Descargar PDF"><Button type="text" icon={<FilePdfOutlined />} style={{ color: '#d32f2f', background: '#fce4e4' }} onClick={() => handleImprimirFacturaDesdeHistorial(item)} /></Tooltip>
                            ) : (
                              <Tooltip title="Ver Detalles"><Button type="text" icon={<EyeOutlined />} onClick={() => { setReciboSeleccionado(item); setIsReciboModalOpen(true); }} /></Tooltip>
                            )}
                          </div>
                        </div>
                      )
                    ))
                  )}
                </div>
              </div>
            </Tabs.TabPane>

          </Tabs>
        </div>
      </div>
    );
  };

  const handleImprimirFacturaDesdeHistorial = async (venta) => {
    // Normalizar productos (por si vienen en string o JSON)
    let productosNormalizados = [];
    if (Array.isArray(venta.productos)) productosNormalizados = venta.productos;
    else if (typeof venta.productos === 'string') {
      try { productosNormalizados = JSON.parse(venta.productos); } catch (e) { productosNormalizados = []; }
    }

    // Calcular subtotales matemáticos
    let sumaSubtotal = 0;
    let sumaDescuentos = 0;

    productosNormalizados.forEach(item => {
      const precioBase = Number(item.precio_unitario || item.precio || 0);
      const cantidad = Number(item.cantidad || 1);
      const porcentajeDescuento = Number(item.descuento || 0);
      const subtotalItem = precioBase * cantidad;
      const ahorroItem = subtotalItem * (porcentajeDescuento / 100);
      sumaSubtotal += subtotalItem;
      sumaDescuentos += ahorroItem;
    });

    // Preparar la estructura exacta que espera tu FacturaFormal
    const infoNegocio = {
      nombre: config.nombre,
      nombre_legal: config.nombre_legal,
      nit: config.identificacion_fiscal,
      direccion: config.direccion,
      telefono: config.telefono,
      logo_url: config.logo_url
    };

    const datosParaImprimir = {
      carrito: productosNormalizados.map(item => ({
        ...item,
        codigo_barras: item.codigo_barras,
        numItems: item.cantidad,
        precioVenta: item.precio_unitario || item.precio
      })),
      totales: {
        subtotal: sumaSubtotal,
        totalDescuento: Math.round(sumaDescuentos),
        total: venta.total,
        impuestos: 0
      },
      numeroFactura: venta.numero_factura,
      ventaId: venta.id,
      fechaVenta: venta.fecha,
      cajero: `${venta.cajero_nombre || ''} ${venta.cajero_apellidos || ''}`.trim() || 'CAJERO',
      clienteNombre: venta.cliente_nombre || clienteSeleccionado?.nombre,
      clienteDocumento: venta.cliente_documento || clienteSeleccionado?.documento,
      clienteTelefono: clienteSeleccionado?.telefono,
      clienteDireccion: clienteSeleccionado?.direccion,
      clienteEmail: clienteSeleccionado?.email,
      metodoPago: venta.metodo_pago,
      efectivoRecibido: venta.efectivo_recibido,
      montoTransferencia: venta.monto_transferencia,
      cambioEntregado: venta.cambio_entregado
    };

    // Generar el PDF y abrirlo en una nueva pestaña
    const nuevaPestana = window.open('', '_blank');
    if (nuevaPestana) nuevaPestana.document.write('Generando PDF, por favor espere...');

    try {
      const blob = await pdf(<FacturaFormal {...datosParaImprimir} infoNegocio={infoNegocio} />).toBlob();
      const url = URL.createObjectURL(blob);
      if (nuevaPestana) {
        nuevaPestana.location.href = url;
      }
    } catch (error) {
      console.error("Error al generar PDF:", error);
      message.error("No se pudo generar el documento.");
      if (nuevaPestana) nuevaPestana.close();
    }
  };

  return (
    <LayoutHome pageSeleccionada="clientes">

      <style>{`
        .scroll-personalizado::-webkit-scrollbar { width: 6px; height: 6px; }
        .scroll-personalizado::-webkit-scrollbar-thumb { background-color: #cbd5e1; border-radius: 10px; }
        .cliente-item-lista { transition: all 0.2s ease; cursor: pointer; border-bottom: 1px solid #f1f5f9; }
        .cliente-item-lista:hover { background-color: #f8fafc; }
        .cliente-item-lista.seleccionado { background-color: #f0fdfa; border-left: 4px solid #22BABB; }
        
        /* Estilos Compactos para Inputs y Selects */
        .toolbar-input { border-radius: 8px !important; border-color: #cbd5e1 !important; box-shadow: none !important; font-size: 14px; }
        .toolbar-input:focus-within, .toolbar-select .ant-select-selector:focus { border-color: #22BABB !important; }
        .toolbar-select .ant-select-selector { border-radius: 8px !important; border-color: #cbd5e1 !important; font-size: 14px; }
      `}</style>

      {/* CONTENEDOR PRINCIPAL */}
      <div style={{ padding: isMobile ? '10px' : '15px', background: '#f8fafc', height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

        {/* 1. HEADER COMPACTO */}
        <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: 'space-between', alignItems: isMobile ? 'stretch' : 'center', gap: '12px', marginBottom: '12px', flexShrink: 0, background: '#fff', padding: '12px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>

          {/* Fila Superior Móvil: Título + Botón Nuevo */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ background: '#e0f2fe', padding: '6px', borderRadius: '8px', display: 'flex' }}>
                <IoPeopleOutline style={{ fontSize: '20px', color: '#22BABB' }} />
              </div>
              <Title level={4} style={{ margin: 0, color: '#0f172a', fontWeight: 800, whiteSpace: 'nowrap' }}>Clientes</Title>
            </div>

            {/* Botón Nuevo Cliente (Visible solo en Móvil aquí arriba) */}
            {isMobile && (
              <Button
                type="primary"
                icon={<IoPersonAddOutline size={16} />}
                onClick={() => { setIsEditing(false); form.resetFields(); setIsModalOpen(true); }}
                style={{ backgroundColor: '#22BABB', borderRadius: '8px', fontWeight: 'bold', border: 'none' }}
              >
                Nuevo
              </Button>
            )}
          </div>

          {/* KPIs Minimalistas */}
          <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? '12px' : '16px', justifyContent: isMobile ? 'space-between' : 'center' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: isMobile ? 'flex-start' : 'center', lineHeight: '1.2' }}>
              <Text type="secondary" style={{ fontSize: '10px', fontWeight: '700', letterSpacing: '0.5px' }}>TOTAL</Text>
              <Text strong style={{ fontSize: '15px', color: '#1e293b' }}>{totalClientes}</Text>
            </div>
            <Divider type="vertical" style={{ height: '24px', margin: 0, borderColor: '#e2e8f0' }} />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: isMobile ? 'flex-start' : 'center', lineHeight: '1.2' }}>
              <Text type="secondary" style={{ fontSize: '10px', fontWeight: '700', letterSpacing: '0.5px' }}>POR COBRAR</Text>
              <Text strong style={{ fontSize: '15px', color: '#0f172a' }}>${Number(totalAdeudado || 0).toLocaleString('es-CO')}</Text>
            </div>
            <Divider type="vertical" style={{ height: '24px', margin: 0, borderColor: '#e2e8f0' }} />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: isMobile ? 'flex-start' : 'center', lineHeight: '1.2' }}>
              <Text type="secondary" style={{ fontSize: '10px', fontWeight: '700', color: carteraVencida > 0 ? '#ef4444' : '#10b981', letterSpacing: '0.5px' }}>VENCIDO</Text>
              <Text strong style={{ fontSize: '15px', color: carteraVencida > 0 ? '#ef4444' : '#10b981' }}>${Number(carteraVencida || 0).toLocaleString('es-CO')}</Text>
            </div>
          </div>

          {/* Botones Acciones Principales (Solo Escritorio) */}
          {!isMobile && (
            <Space style={{ justifyContent: 'flex-end' }}>
              {hasPermission('clientes:exportar') && (
                <Button
                  icon={<DownloadOutlined size={18} />}
                  onClick={() => setOpenExport(true)}
                  style={{ display: 'flex', alignItems: 'center', height: '36px', borderRadius: '8px', borderColor: '#cbd5e1', color: '#475569', fontWeight: '600' }}
                >
                  Exportar
                </Button>
              )}
              <Button
                type="primary"
                icon={<IoPersonAddOutline size={18} />}
                onClick={() => { setIsEditing(false); form.resetFields(); setIsModalOpen(true); }}
                style={{ display: 'flex', alignItems: 'center', height: '36px', borderRadius: '8px', backgroundColor: '#22BABB', fontWeight: '600', border: 'none' }}
              >
                Nuevo Cliente
              </Button>
            </Space>
          )}
        </div>

        {/* 2. BARRA DE BÚSQUEDA Y FILTROS SECUNDARIOS */}
        <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', marginBottom: '15px', flexShrink: 0 }}>
          <Input
            className="toolbar-input"
            placeholder="Buscar por nombre o documento..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            allowClear
            prefix={<IoSearchOutline color="#94a3b8" size={18} style={{ marginRight: '6px' }} />}
            style={{ flex: 1, height: '38px' }}
          />

          {!isMobile && opcionesCreadores.length > 1 && (
            <Select
              className="toolbar-select"
              placeholder="Vendedor"
              value={filtroCreador || ''}
              onChange={(val) => setFiltroCreador(val)}
              style={{ width: 180, height: '38px' }}
              options={[
                { value: '', label: 'Todos los vendedores' },
                ...opcionesCreadores.map(u => ({ value: u.id, label: u.nombre }))
              ]}
            />
          )}

          {!isMobile && categorias.length > 0 && (
            <Select
              className="toolbar-select"
              placeholder="Categoría"
              value={filtroCategoria || ''}
              onChange={(val) => setFiltroCategoria(val)}
              style={{ width: 180, height: '38px' }}
              options={[
                { value: '', label: 'Todas las categorías' },
                ...categorias.map(cat => ({ value: cat.id, label: cat.nombre }))
              ]}
            />
          )}

          {/* Botón de Filtros Móvil */}
          {isMobile && (
            <Badge count={filtrosActivos} size="small">
              <Button
                icon={<IoFilterOutline size={20} />}
                style={{ height: '38px', width: '38px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                onClick={() => setDrawerFiltros(true)}
              />
            </Badge>
          )}
        </div>

        {/* CONTENEDOR MASTER-DETAIL */}
        <div style={{ flex: 1, minHeight: 0, display: 'flex', gap: '16px' }}>

          {/* COLUMNA LISTA DE CLIENTES */}
          <div style={{ width: isMobile ? '100%' : '35%', background: '#fff', borderRadius: '12px', display: 'flex', flexDirection: 'column', border: '1px solid #e2e8f0', boxShadow: '0 1px 2px rgba(0,0,0,0.02)', overflow: 'hidden' }}>

            {/* FILTROS RADIO BUTTONS INTEGRADOS SOBRE LA LISTA */}
            <div style={{ padding: '12px', borderBottom: '1px solid #f1f5f9', backgroundColor: '#fafaf9' }}>
              <div style={{ width: '100%', overflowX: 'auto', paddingBottom: isMobile ? '4px' : '0' }} className="scroll-personalizado">
                <Radio.Group
                  value={filtro}
                  onChange={(e) => setFiltro(e.target.value)}
                  buttonStyle="solid"
                  style={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    width: isMobile ? 'max-content' : '100%'
                  }}
                >
                  <Radio.Button value="todos" title='Todos los clientes' style={{ flex: isMobile ? 'none' : 1, textAlign: 'center', borderRadius: '8px 0 0 8px', fontSize: '13px' }}>Todos</Radio.Button>
                  <Radio.Button value="alDia" title='Clientes al día' style={{ flex: isMobile ? 'none' : 1, textAlign: 'center', fontSize: '13px' }}>Al Día</Radio.Button>
                  <Radio.Button value="deudores" title='Clientes que deben' style={{ flex: isMobile ? 'none' : 1, textAlign: 'center', fontSize: '13px' }}>Deben</Radio.Button>
                  <Radio.Button value="vencidos" title='Clientes con cuentas vencidas' style={{ flex: isMobile ? 'none' : 1, textAlign: 'center', fontSize: '13px' }}>Vencidos</Radio.Button>
                  <Radio.Button value="conAlerta" title='Clientes con alertas CRM' style={{ flex: isMobile ? 'none' : 1, textAlign: 'center', borderRadius: '0 8px 8px 0', fontSize: '13px' }}>Alerta</Radio.Button>
                </Radio.Group>
              </div>
            </div>

            <div style={{ flex: 1, overflowY: 'auto' }} className="scroll-personalizado">
              <List
                loading={loading}
                dataSource={clientesFiltrados}
                locale={{ emptyText: 'No se encontraron clientes.' }}
                renderItem={item => (
                  <div
                    className={`cliente-item-lista ${clienteSeleccionado?.id === item.id && !isMobile ? 'seleccionado' : ''}`}
                    onClick={() => seleccionarCliente(item)}
                    style={{ padding: '12px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1, minWidth: 0 }}>
                      <Avatar size="default" style={{ backgroundColor: item.tiene_alerta ? '#faad14' : '#e2e8f0', color: item.tiene_alerta ? '#fff' : '#64748b' }} icon={item.tiene_alerta ? <IoNotificationsOutline /> : <UserOutlined />} />
                      <div style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                        <Text strong style={{ fontSize: '13px', color: '#1e293b', textOverflow: 'ellipsis', overflow: 'hidden' }}>{item.nombre}</Text>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <Text type="secondary" style={{ fontSize: '11px' }}>{item.documento || 'Sin doc.'}</Text>
                          {item.creador_nombre && (
                            <Text type="secondary" style={{ fontSize: '10px', color: '#94a3b8' }}>
                              • Por: {item.creador_nombre}
                            </Text>
                          )}
                        </div>
                      </div>
                    </div>
                    <div style={{ textAlign: 'right', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', minWidth: '70px' }}>
                      {Number(item.saldo_pendiente) > 0 ? (
                        <>
                          <Text strong style={{ fontSize: '13px', color: '#f5222d' }}>${Number(item.saldo_pendiente).toLocaleString('es-CO')}</Text>
                          <Text style={{ fontSize: '9px', color: '#f5222d' }}>DEBE</Text>
                        </>
                      ) : (
                        <Tag color="success" style={{ margin: 0, fontSize: '10px', borderRadius: '8px' }}>Al día</Tag>
                      )}
                    </div>
                    {isMobile && <IoChevronForwardOutline style={{ color: '#cbd5e1', marginLeft: '12px' }} />}
                  </div>
                )}
              />
            </div>
          </div>

          {/* COLUMNA FICHA DEL CLIENTE */}
          {!isMobile && (
            <div style={{ flex: 1, background: '#fff', borderRadius: '12px', padding: '16px', border: '1px solid #e2e8f0', boxShadow: '0 1px 2px rgba(0,0,0,0.02)', overflow: 'hidden' }}>
              {renderFichaCliente()}
            </div>
          )}
        </div>
      </div>

      {/* MODAL: Crear / Editar Cliente Extraído */}
      <ModalCrearCliente
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        form={form}
        handleCrearCliente={handleCrearCliente}
        isEditing={isEditing}
        loading={loading}
        zonas={zonas}
        categorias={categorias}
        clientesSeguros={clientesSeguros}
        clienteSeleccionado={clienteSeleccionado}
        configCampos={configCamposParseada}
        onOpenConfig={() => setIsConfigModalOpen(true)}
        hasPermission={hasPermission}
      />

      {/* MODAL: Configuración de Campos Obligatorios */}
      <ModalConfigCampos
        isOpen={isConfigModalOpen}
        setIsOpen={setIsConfigModalOpen}
      />

      <ModalExportarClientes
        openExport={openExport}
        setOpenExport={setOpenExport}
        clientesFiltrados={clientesFiltrados}
        clientesSeguros={clientesSeguros}
        opcionesCreadores={opcionesCreadores}
      />

      {/* MODAL MÓVIL: Ficha del Cliente */}
      {isMobile && (
        <Modal
          title={<Title level={4} style={{ margin: 0 }}>Ficha del Cliente</Title>}
          open={isDetailModalOpenMobile}
          onCancel={() => setIsDetailModalOpenMobile(false)}
          footer={null}
          width="100%"
          style={{ top: 10, maxWidth: '100vw', margin: '0 auto', paddingBottom: 0 }}
          styles={{ body: { padding: '16px', height: '82vh', overflow: 'hidden' } }}
        >
          <div style={{ height: '100%' }}>
            {renderFichaCliente()}
          </div>
        </Modal>
      )}

      {/* --- DRAWER DE FILTROS Y ACCIONES PARA MÓVIL --- */}
      {isMobile && (
        <Drawer
          title={<span style={{ fontWeight: '700' }}>Filtros y Acciones</span>}
          placement="bottom"
          onClose={() => setDrawerFiltros(false)}
          open={drawerFiltros}
          height="auto"
          styles={{ body: { padding: '20px', display: 'flex', flexDirection: 'column', gap: '15px' } }}
        >
          {opcionesCreadores.length > 1 && (
            <div>
              <Text type="secondary" style={{ fontSize: '12px', fontWeight: '600', textTransform: 'uppercase' }}>Vendedor</Text>
              <Select
                placeholder="Todos los vendedores"
                value={filtroCreador || ''}
                onChange={(val) => setFiltroCreador(val)}
                style={{ width: '100%', height: '40px', marginTop: '5px' }}
                options={[
                  { value: '', label: 'Todos los vendedores' },
                  ...opcionesCreadores.map(u => ({ value: u.id, label: u.nombre }))
                ]}
              />
            </div>
          )}

          {categorias.length > 0 && (
            <div>
              <Text type="secondary" style={{ fontSize: '12px', fontWeight: '600', textTransform: 'uppercase' }}>Tipo de Cliente</Text>
              <Select
                placeholder="Todas las categorías"
                value={filtroCategoria || ''}
                onChange={(val) => setFiltroCategoria(val)}
                style={{ width: '100%', height: '40px', marginTop: '5px' }}
                options={[
                  { value: '', label: 'Todas las categorías' },
                  ...categorias.map(cat => ({ value: cat.id, label: cat.nombre }))
                ]}
              />
            </div>
          )}

          <Divider style={{ margin: '10px 0' }} />

          <Space direction="vertical" style={{ width: '100%' }} size="middle">
            {hasPermission('clientes:exportar') && (
              <Button block icon={<DownloadOutlined size={18} />} onClick={() => { setDrawerFiltros(false); setOpenExport(true); }} style={{ borderRadius: '8px', height: '45px', borderColor: '#10b981', color: '#10b981', fontWeight: '600' }}>
                Exportar Base de Clientes
              </Button>
            )}

            {(hasPermission('configuracion:ver_administracion') || hasPermission('clientes:configurar_campos')) && (
              <Button block icon={<SettingOutlined size={18} />} onClick={() => { setDrawerFiltros(false); setIsConfigModalOpen(true); }} style={{ borderRadius: '8px', height: '45px', fontWeight: '600' }}>
                Configurar Formulario
              </Button>
            )}
          </Space>
        </Drawer>
      )}

      {/* MODAL DE GESTIÓN DE DEUDA (SOLO FORMULARIO DE PAGO) */}
      <Modal
        title={<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}><IoCashOutline size={20} style={{ color: '#22BABB' }} /><span style={{ fontWeight: 700, fontSize: '16px', letterSpacing: '-0.3px' }}>{isAbonoGlobal ? 'ABONO A DEUDA TOTAL' : `ABONO A FACTURA ${ventaSeleccionada?.id?.toString().slice(0, 8)}`}</span></div>}
        open={isDebtOpen}
        onCancel={() => { setIsDebtOpen(false); setIsAbonando(false); setIsAbonoGlobal(false); }}
        footer={null} width={450} centered
      >
        <div style={{ marginBottom: '20px', textAlign: 'center', padding: '16px', backgroundColor: '#f8fafc', borderRadius: '12px', border: '1px dashed #cbd5e1' }}>
          <Text type="secondary" style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '1px' }}>
            {isAbonoGlobal ? 'Saldo Pendiente Global' : 'Saldo Pendiente de esta Factura'}
          </Text>
          <div style={{ fontSize: '32px', fontWeight: 800, color: '#ff4d4f', marginTop: '4px' }}>
            ${Number(isAbonoGlobal ? clienteSeleccionado?.saldo_pendiente : ventaSeleccionada?.saldo_pendiente_factura).toLocaleString('es-CO')}
          </div>
        </div>

        <Form form={formAbono} layout="vertical" onFinish={handleConfirmarAbono} requiredMark={false}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="monto_abono"
                label={<Text strong style={{ fontSize: '12px' }}>VALOR A PAGAR</Text>}
                rules={[
                  { required: true, message: 'Indique el monto' },
                  () => ({
                    validator(_, value) {
                      const maxPermitido = isAbonoGlobal ? clienteSeleccionado?.saldo_pendiente : ventaSeleccionada?.saldo_pendiente_factura;
                      if (!value || Number(value) <= Number(maxPermitido)) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error(`El valor supera la deuda`));
                    },
                  }),
                ]}
              >
                <InputNumber
                  controls={false}
                  prefix={<Text style={{ color: '#bfbfbf' }}>$</Text>}
                  size="large"
                  placeholder="0"
                  style={{ width: '100%', borderRadius: '8px', fontSize: '18px', fontWeight: 600 }}
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                  parser={(value) => value?.replace(/\$\s?|(\.*)/g, '') || ''}
                  suffix={
                    <div style={{ pointerEvents: 'auto', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                      <Button
                        type="link"
                        size="small"
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={(e) => {
                          e.stopPropagation();
                          const deudaAPagar = Number(isAbonoGlobal ? clienteSeleccionado?.saldo_pendiente : ventaSeleccionada?.saldo_pendiente_factura) || 0;
                          formAbono.setFieldsValue({ monto_abono: deudaAPagar });
                          formAbono.validateFields(['monto_abono']);
                        }}
                        style={{ fontSize: '11px', color: '#22BABB', padding: 0 }}
                      >
                        Pagar todo
                      </Button>
                    </div>
                  }
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="metodo_pago"
                label={<Text strong style={{ fontSize: '12px' }}>MÉTODO</Text>}
                rules={[{ required: true, message: 'Selecciona un método' }]}
              >
                <Select size="large" placeholder="Seleccione..." style={{ borderRadius: '8px' }}>
                  <Select.Option value="efectivo">Efectivo</Select.Option>
                  <Select.Option value="nequi">Nequi / Davi</Select.Option>
                  <Select.Option value="transferencia">Transferencia</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.metodo_pago !== currentValues.metodo_pago}>
            {({ getFieldValue }) => (
              getFieldValue('metodo_pago') === 'efectivo' ? (
                <div style={{ marginBottom: '16px', marginTop: '-8px' }}>
                  <Text style={{ fontSize: '11px', color: '#fa8c16', lineHeight: '1.2' }}>
                    * El pago en efectivo ingresará automáticamente a tu cuadre de caja actual.
                  </Text>
                </div>
              ) : null
            )}
          </Form.Item>

          <Form.Item name="nota" label={<Text strong style={{ fontSize: '12px' }}>NOTAS U OBSERVACIONES (Opcional)</Text>}>
            <Input.TextArea rows={2} style={{ borderRadius: '8px' }} />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            block
            size="large"
            loading={loading}
            disabled={loading}
            style={{ height: '50px', backgroundColor: '#22BABB', borderRadius: '12px', fontWeight: 700, fontSize: '15px' }}>
            CONFIRMAR PAGO
          </Button>
        </Form>
      </Modal>

      <TicketDetalleVentaFactura
        isOpen={isDetalleFacturaOpen}
        onClose={() => setIsDetalleFacturaOpen(false)}
        venta={facturaDetalleSeleccionada}
        onPrint={(venta) => {
          message.info(`Reimprimiendo documento ${venta.id.toString().slice(0, 8)}...`);
        }}
      />

      {/* MODAL: Comprobante de Abono */}
      <TicketComprobante
        setIsReciboModalOpen={setIsReciboModalOpen}
        isReciboModalOpen={isReciboModalOpen}
        reciboSeleccionado={reciboSeleccionado}
        clienteSeleccionado={clienteSeleccionado}
      />
    </LayoutHome>
  );
};

export default Clientes;